import { render, staticRenderFns } from "./AllotPickUp.vue?vue&type=template&id=e1bab306&scoped=true"
import script from "./AllotPickUp.vue?vue&type=script&lang=js"
export * from "./AllotPickUp.vue?vue&type=script&lang=js"
import style0 from "./AllotPickUp.vue?vue&type=style&index=0&id=e1bab306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bab306",
  null
  
)

export default component.exports